import { ThunkAction } from 'redux-thunk';
import { Action, configureStore } from '@reduxjs/toolkit';

import rootReducer, { RootState } from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.onConfirm'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;

// Exponer el store en window para Cypress E2E
if ((window as any).Cypress) {
  (window as any).__store__ = store;
}

export default store;
